import { useEffect, useState } from "react"
import { urlapi } from "../../lib/backend/data"
import Select from 'react-select';
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const SelectorCuentasFacturacion = (props) => {
    const {
        extraOptions
    } = props
    const opciones_default = extraOptions ? extraOptions : []
    const [ estados, setEstados ] = useState([])
    const [ estadosCarga, setEstadosCarga ] = useState([])
    const [ loadingEstados, setLoadingEstados ] = useState(true)
    const session = useSelector(state => state.miusuario)
    const isMulti = typeof props.isMulti !== "undefined" ? true : false
    const [ filtroEstado, setFiltroEstado ] = useState([])
    const titulo = props.titulo ? props.titulo : 'Cuenta de facturación'
    const full_payload = typeof props.full_payload !== "undefined" ? true : false

    const handleChangeSelectEstado = (e) => {
        if(isMulti === true){
            let opciones = []
            if(e){
                e.map(valor => {
                    opciones.push(valor.value)
                })
            }
            if(props.onChange) props.onChange(opciones)
            return setFiltroEstado(opciones)
        } else {
            let data = e
            if(full_payload === true){
                console.log(e.value)
                const i = estadosCarga.findIndex(es => es.codigo_estado === e.value)
                if(i > -1) data = estadosCarga[i]
            }
            if(props.onChange) props.onChange(data)
            return e
        }
    }

    const obtenerEstados = () => {
        return fetch(`${urlapi}/cuentas-facturacion/select`,{
            method: "GET",
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${session.tokenSession}`
            },
        })
        .then(pros => pros.json())
        .then(data => { 
            if(!data){

            } else if(data.errorMessage){
                toast.error(data.errorMessage)
                return this.setState({ loadingFormulario: false })
            } else if( Array.isArray(data) !== false){
                setEstadosCarga(data.map(e => ({ ...e, label: `${e.id} - ${e.empresa?.razon_social}`})))
                setEstados([...opciones_default, ...data.map(e => ({ value: e._id, label: `${e.id} - ${e.empresa?.razon_social}` }))])
            }
            return setLoadingEstados(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información")
            return setLoadingEstados(false)
        })
    }

    useEffect(() => {
        obtenerEstados()
    }, [])

    if(estados.length < 1) return null

    return <div className="mb-3">
        <label className='d-block form-control-label'>{titulo}</label>
                    <Select 
                        style={{ marginBottom: 10 }}
                        onChange={handleChangeSelectEstado}
                        isLoading={loadingEstados}
                        loadingMessage={() => "Cargando datos"}
                        isMulti={isMulti}
                        isClearable
                        options={estados}
                        defaultValue={''}
                        placeholder="Escribe para buscar"
                        noOptionsMessage={()=>'Sin opciones'}
                        />
    </div>
}

export default SelectorCuentasFacturacion